import { ButtonWithIcon } from '@blueprint/ui';
import styled from '@emotion/styled';

export const StyledTable = styled('table')`
    font-family: monospace;
    border-collapse: collapse;

    thead > tr > td {
        background: ${(props) => props.theme.colors['primary-dark']};
        color: ${(props) => props.theme.colors['white']};
    }

    th {
        background: ${(props) => props.theme.colors['primary-mid-muted']};
    }

    td,
    th {
        padding: ${(props) => props.theme.spacing['8px']};
    }

    tr:nth-child(even):not(.forced) {
        background-color: ${(props) => props.theme.colors['neutral-1']};
    }

    .forced {
        background-color: ${(props) => props.theme.colors['tone-blue-t3']};
    }

    select {
        font-family: inherit;
    }
`;

export const Container = styled('div')<{ height?: number }>`
    height: 100%;
    width: 100%;
    overflow: scroll;
`;

export const FixedButtonWithIcon = styled(ButtonWithIcon)`
    position: fixed;
    bottom: 10px;
    right: 10px;
    z-index: 999;
    min-width: unset;
`;

export const Overlay = styled('div')<{ isShowing: boolean }>`
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 1001;
    background: ${(props) => props.theme.colors.white};
    display: ${(props) => (props.isShowing ? 'block' : 'none')};
`;
